import { useState } from "react"
import MainContainer from "../common/MainContainer"
import PersonsListing from "./PersonsListing";
import useUser from "../../hooks/useUser";
import AddChip from "../common/ActionChip/AddChip";


export default function PersonsManagement({ setBlockScreen }: any) {

  const [openActionModal, setOpenActionModal] = useState(false)
  const [action, setAction] = useState<'view' | 'edit' | 'create'>('view')
  const { userAdmin }: any = useUser()

  return (
    <>
      <MainContainer>
        {(userAdmin) && (
          <div className="persons-actions-bar">
            <span className="persons-actions-bar-add-btn">
              <AddChip
                onClick={() => { setAction('create'); setOpenActionModal(true) }}
                label='Nueva Persona'
              />
            </span>
          </div>
        )}
        <PersonsListing
          openActionModal={openActionModal}
          setOpenActionModal={setOpenActionModal}
          action={action}
          canEdit={userAdmin}
          setAction={setAction}
          setBlockScreen={setBlockScreen} />

      </MainContainer>
    </>
  );
}
